import React from 'react'

const Quetaljuegoyo = () => {
    return (
        <div className='container fondotransparente p-5'>

            <center><h1 classname="botonbordeazul text-white px-5 mx-5 py-3">¿Qué tal juego yo?</h1></center>

            <p><strong>Evalúa tu Comportamiento:</strong></p>



            <p><strong>Evalúa tu comportamiento</strong>. <strong>El cuestionario solo tiene valor orientador y no implica un diagnóstico de enfermedad. Este último solo podrá ser efectuado por un profesional de salud mental.</strong></p>



            <p>¿Crees que tienes o has tenido alguna vez problemas con el juego?</p>



            <p>¿Piensa usted en el juego casi todo el tiempo?</p>



            <p>¿Te has sentido alguna vez culpable por jugar o por lo que te ocurre cuando juegas?</p>



            <p>¿Has intentado alguna vez dejar de jugar y no has sido capaz de ello?</p>



            <p>¿Planifica volver a jugar para recuperar lo perdido?</p>



            <p>Cuando juega, ¿se empeña en seguir jugando hasta ganar?</p>



            <p>¿Alguna vez jugo más tiempo del planeado y /o incrementado el monto de la apuesta para obtener mayor satisfacción?</p>



            <p>¿Ha descuidado obligaciones laborables y/o familiares por jugar?</p>



            <p>¿Has sacado alguna vez dinero de casa/trabajo para jugar o para pagar deudas?</p>



            <p>¿Pides dinero para poder jugar? ¿vendiste pertenencias o delinquido para financiar el juego? ¿Dejas de pagar obligaciones y dedicas el dinero al juego?&nbsp;</p>

            <p>¿Tus familiares o amigos te dicen que juegas demasiado y te animan a dejarlo?</p>



            <p>¿Oculta información o mientes a familiares, amigos y /o profesionales con respecto al juego?</p>



            <p>Si has contestado que&nbsp;<strong>SÍ</strong>&nbsp;a alguna de estas preguntas, te sugerimos tomarlo como <strong>un signo de alerta,</strong> ya que tu conducta podría derivar en riesgos de futuros problemas de juego.</p>



            <p>Si has contestado que <strong>si</strong> a tres o cuatro de las preguntas, indicaría que <strong>posiblemente tienen problemas con el juego</strong>, consulte a un profesional de la Salud mental para que lo asesore al respecto o a nosotros que estamos para ayudarlo.</p>



            <p>Si la respuesta es <strong>si</strong>, a más de cinco preguntas, es conveniente que consulte con un profesional de la Salud Mental. Usted puede estar dentro del grupo poblacional que <strong>tiene problemas con el juego</strong> (Persona con trastorno de conducta por juego de apuestas.)</p>

        </div>
    )
}

export default Quetaljuegoyo